<template>
  <PagesFellowsComponent :pageData="data" />
</template>

<script setup>
const queryPath = queryParticipantsPage(baseStrapiGetSlugQueryObjectFromRoute())
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryPath } }
  )
})

if (!data?.value?.data?.id || error?.value) {
  throw createError({ statusCode: 404 })
}

pageSetHead(data)
</script>
